import React from 'react'

export const Button = ({ children, inverted = false, tertiary = false, secondary = false, className = '', disabled = false, ...props }) => {
  let classNames

  if (inverted && tertiary) {
    classNames = 'bg-transparent border-tertiary text-tertiary hover:bg-tertiary hover:text-white'
  } else if (tertiary) {
    classNames = 'bg-tertiary border-tertiary text-white hover:bg-white hover:text-tertiary'
  } else if (inverted && !secondary) {
    classNames = 'bg-white border-white text-primary hover:bg-primary hover:text-white'
  } else if (inverted && secondary) {
    classNames = 'bg-primary border-white text-white hover:bg-white hover:text-primary'
  } else if (!inverted && !secondary) {
    classNames = 'bg-primary border-primary text-white hover:bg-white hover:text-primary'
  } else if (!inverted && secondary) {
    classNames = 'bg-transparent border-primary text-primary hover:bg-primary hover:text-white'
  }

  if (disabled) {
    classNames = `cursor-not-allowed opacity-50 ${classNames}`
  }

  return (
    <button
      type="button"
      disabled={disabled}
      className={`
        cursor-pointer
        inline-block
        border-2
        uppercase
        py-3
        px-6
        font-medium
        text-center
        text-sm
        focus:outline-none
        focus:ring-2
        focus:ring-offset-2
        focus:ring-primary-darker
        transition
        duration-200
        ease-in-out
        shadow-sm
        rounded-sm
        space-x-2


        ${classNames}
        ${className}
      `}
      {...props}
    >
        { children }
    </button>
  )
}

export default Button
